export class LayerVisibility {

    layerid: string;
    sublayerid?: number;
    sublayerName?: string;
    visible: boolean;

    constructor(layerid: string, sublayerid: number, sublsublayerName: string, visible: boolean) {
        this.layerid = layerid;
        this.sublayerid = sublayerid;
        this.sublayerName = sublsublayerName;
        this.visible = visible;
    }
}
